<div *ngIf="!isCard" class="bg-turquoise/20 text-white text-sm font-medium py-2 px-5 rounded-full shadow-lg flex items-center gap-2">
    <img src="https://imgix.cosmicjs.com/abe62380-5a82-11f0-ae5a-0f56aa053fcd-alarm-clock-check-1.svg" alt="clock icon"
        width="24" height="24" loading="lazy">

    <span *ngIf="!isTimeUp">
        Price jumps in {{ days }}d {{ hours }}h {{ minutes }}m {{ seconds }}s
    </span>
    <span *ngIf="isTimeUp">
        Time's up!
    </span>
</div>
<div *ngIf="isCard" class="text-white text-base font-medium flex items-center gap-2" [class.text-sm]="isMobile">
    <img *ngIf="!isMobile" src="https://imgix.cosmicjs.com/abe62380-5a82-11f0-ae5a-0f56aa053fcd-alarm-clock-check-1.svg" alt="clock icon"
        width="24" height="24">
    <span *ngIf="!isTimeUp">
        {{ days }}d {{ hours }}h {{ minutes }}m {{ seconds }}s left
    </span>
</div>